/* tslint:disable */
import styled from '@emotion/styled';
import React, { useState } from 'react';
import { theme } from '@kindur/components';
import Img from 'gatsby-image';
import colors from '../../styles/colors';

export default ({ placeholder }) => {
  const [isVisible, showVideo] = useState(false);

  return (
    <Container>
      <Intro>
        <Title>Our Story</Title>
        <Copy>
          Rhian Horgan, Kindur's Founder and CEO, describes why she started Kindur specifically to help make the
          transition to retirement simple and easy.
        </Copy>
      </Intro>
      <VideoContainer>
        {isVisible ? (
          <iframe
            id="our-story-video"
            src="https://player.vimeo.com/video/347527567?autoplay=1"
            frameBorder="0"
            allow="autoplay"
            allowFullScreen
          ></iframe>
        ) : (
          <Placeholder onClick={() => showVideo(true)}>
            <Img fluid={placeholder} imgStyle={{transition: 'all .2s ease-in-out'}}/>
          </Placeholder>
        )}
      </VideoContainer>
    </Container>
  );
};

/*
 *   STYLES
 */

const Container = styled('section')`
  background-color: ${colors.LightGreen};
  padding: ${theme.spacing.small * 10}px ${theme.spacing.standard * 8}px;

  ${theme.breakpoints.tabletDown} {
    padding: ${theme.spacing.small * 7}px ${theme.spacing.small * 2}px;
  }
`;

const Intro = styled('div')`
  ${theme.breakpoints.tabletUp} {
    margin-left: 2em;
    max-width: 90%;
  }
`;

const Title = styled('h2')`
  font-family: 'DM Sans', sans-serif;
  font-size: 2em;
  font-weight: 700;
  line-height: 1;
`;

const Copy = styled('p')`
  font-family: 'DM Sans', sans-serif;
  font-size: ${theme.fontSizes.medium};
  line-height: 1.5em;
  margin-bottom: ${theme.spacing.standard * 2}px;
`;

const VideoContainer = styled('div')`
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;

  iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
`;

const Placeholder = styled('div')`
  position: relative;
  background-color: ${theme.colors.Black};

  &:hover {
    cursor: pointer;
    img {
      transform: scale(1.1);
    }
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    background: transparent;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
    border: 0;
    width: 0;
    border-color: transparent transparent transparent #202020;
    border-style: solid;
    border-width: 12px 0px 12px 20px;
    margin-left: 3px;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 60px;
    width: 60px;
    z-index: 1;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.4);
  }
`;
